import { buildSearchStateUrl } from './searchScope';

// Result sections that are cached/swapped when scope changes.
const RESULT_BLOCK_SELECTOR = [
  '.semantic-search-error',
  '.semantic-search-top-results',
  '.js-semantic-search-paa-mobile',
  '.js-semantic-remaining-results',
  '.semantic-search-no-results',
  '.semantic-search-end-of-feed',
  '.js-semantic-search-scope-skeleton',
].join(', ');

// Extract search result blocks from content.
export function getResultsMarkup($content) {
  if (!$content || !$content.length) return '';
  return $('<div>').append($content.children(RESULT_BLOCK_SELECTOR).clone()).html();
}

/**
 * Reinsert sorted semantic result rows back into their original semantic slots
 * so ad placements between rows stay in their original positions.
 */
export function replaceRowsInListSlots($list, originalRows, replacementRows) {
  const slotMarkers = originalRows.map(() => document.createComment('semantic-row-slot'));
  originalRows.forEach((row, index) => $(row).replaceWith(slotMarkers[index]));
  replacementRows.forEach((row, index) => {
    if (slotMarkers[index]) {
      $(slotMarkers[index]).replaceWith(row);
    } else {
      $list.append(row);
    }
  });
  slotMarkers.slice(replacementRows.length).forEach((marker) => $(marker).remove());
}

/**
 * Refresh the existing remaining-results section in place, preserving ad-safe row slots.
 */
function syncRemainingResultsSectionInPlace($currentSection, $incomingSection) {
  if (!$currentSection.length || !$incomingSection.length) {
    return false;
  }

  const nextAriaLabel = $incomingSection.attr('aria-label');
  if (nextAriaLabel) {
    $currentSection.attr('aria-label', nextAriaLabel);
  } else {
    $currentSection.removeAttr('aria-label');
  }

  const $currentHeader = $currentSection.find('.semantic-search-section__header').first();
  const $incomingHeader = $incomingSection.find('.semantic-search-section__header').first();
  if ($currentHeader.length && $incomingHeader.length) {
    $currentHeader.replaceWith($incomingHeader);
  }

  const $currentList = $currentSection.find('.semantic-remaining-results__list').first();
  const $incomingList = $incomingSection.find('.semantic-remaining-results__list').first();
  if (!$currentList.length || !$incomingList.length) {
    return true;
  }
  replaceRowsInListSlots(
    $currentList,
    $currentList.children('li.semantic-remaining-result').toArray(),
    $incomingList.children('li.semantic-remaining-result').toArray(),
  );
  return true;
}

// Replace current results with new markup.
export function renderResultsMarkup($content, markup) {
  if (!markup) {
    $content.children(RESULT_BLOCK_SELECTOR).remove();
    return;
  }

  const $incomingContent = $('<div>').append($.parseHTML(markup, document, true));
  const preservedRemaining = syncRemainingResultsSectionInPlace(
    $content.children('.js-semantic-remaining-results').first(),
    $incomingContent.children('.js-semantic-remaining-results').first(),
  );

  if (preservedRemaining) {
    $content.children(RESULT_BLOCK_SELECTOR).not('.js-semantic-remaining-results').remove();
  } else {
    $content.children(RESULT_BLOCK_SELECTOR).remove();
  }

  let $anchor = $content.find('.semantic-search-form').first();
  $incomingContent.children(RESULT_BLOCK_SELECTOR).each((_, node) => {
    const $node = $(node);
    if (preservedRemaining && $node.is('.js-semantic-remaining-results')) {
      $anchor = $content.children('.js-semantic-remaining-results').first();
      return;
    }
    $anchor = $node.insertAfter($anchor);
  });
}

// Fetch results for given scope, using cache if available.
export function fetchScopeMarkup(scope, cache, sortMode) {
  if (Object.prototype.hasOwnProperty.call(cache, scope)) {
    return Promise.resolve(cache[scope]);
  }
  const targetUrl = buildSearchStateUrl(window.location.href, scope, sortMode);
  return $.get(targetUrl).then((html) => {
    const $parsed = $('<div>').append($.parseHTML(html, document, true));
    return getResultsMarkup($parsed.find('.semantic-search-content').first());
  });
}
